import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 16px;
`;

export const Message = styled.div`
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 20px;
	font-weight: 600;
	margin-bottom: 24px;
`;

export const Buttons = styled.div`
	display: flex;
	justify-content: end;
	gap: 16px;
`;
